/* eslint-disable */
/* tslint:disable */

/** checkRpps
 * method: get
 * summary: Check if rpps number along with first name and last name exists in rpps database.
 */

import type {
  CheckRppsResponseDto,
  BadRequestResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/rpps/check`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/rpps/check`

export type CheckRppsSuccess = CheckRppsResponseDto
export type CheckRppsError = BadRequestResponseDto | ApiResponseDto
